import { defineComponent as _defineComponent } from 'vue'
import { UserSearchCriteria } from '@/interfaces/api/general/company';
import { defineMessages } from '@/lib/i18n';
import { isValidLength, noLineBreak, required } from '@/lib/rule';
import store from '@/store';
import { dispatchUpdateUserSearchCriteria } from '@/store/main/actionsMain';
import {
  readAssertedCompanyId,
  readAssertedUserProfile,
} from '@/store/main/getters';
import DeleteMyFilterDialog from '@/views/pages/sdsIndex/DeleteMyFilterDialog.vue';
import { onBeforeUnmount, ref, watchEffect } from 'vue';
import MyFilterIcon from '@/components/icons/MyFilterIcon.vue';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyFilterSelector',
  props: {
    userSearchCriteriaList: null,
    activeMyFilter: null
  },
  emits: ["updated", "deleted", "applyMyFilter"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'updated', criteria: UserSearchCriteria): void;
  (e: 'deleted'): void;
  (e: 'applyMyFilter', criteria: UserSearchCriteria): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  userSearchCriteriaList: UserSearchCriteria[];
  activeMyFilter: UserSearchCriteria | undefined;
};

const m = defineMessages({
  noMyFilter: 'こちらに保存したフィルターが表示されます。',
  editName: '名称編集',
});




const activeEditCriteria = ref<string>();
const formRef = ref();
const isValidForm = ref(false);
const formName = ref('');
const tooltipRef = ref<HTMLElement>();
const isLoading = ref(false);
const showDeleteDialog = ref(false);
const deleteSearchCriteriaId = ref<string>('');

const { COMPANY_FEATURES, isFeatureActive, generateInactiveMessage } =
  useCompanyFeatureComposable();

const showMyFilterTooltip = ref(false);

const isActiveMyFilter = (uuid: string) => {
  return props.activeMyFilter?.uuid === uuid;
};

const handleNameClick = (criteria: UserSearchCriteria) => {
  showMyFilterTooltip.value = false;
  emits('applyMyFilter', criteria);
};

const handleEditClick = (uuid: string) => {
  const width = tooltipRef.value?.getBoundingClientRect().width;
  activeEditCriteria.value = uuid;
  formName.value =
    props.userSearchCriteriaList.find((criteria) => criteria.uuid === uuid)
      ?.name ?? '';
  // form に切り替わったときにもとの幅を維持する
  if (tooltipRef.value) {
    tooltipRef.value.style.width = `${width}px`;
  }
};

const handleSaveClick = async (uuid: string) => {
  formRef.value?.validate();
  if (!isValidForm.value) {
    return;
  }
  const criteria = props.userSearchCriteriaList.find(
    (criteria) => criteria.uuid === uuid
  );
  if (!criteria) {
    throw new Error('Criteria not found');
  }

  try {
    isLoading.value = true;
    const response = await dispatchUpdateUserSearchCriteria(store, {
      userId: readAssertedUserProfile(store).uuid,
      companyId: readAssertedCompanyId(store),
      searchCriteriaId: uuid,
      name: formName.value,
    });
    activeEditCriteria.value = undefined;
    if (!response?.data) {
      throw new Error('Failed to update user search criteria');
    }
    emits('updated', response.data);
  } finally {
    isLoading.value = false;
  }
};

const handleDeleteClick = async (uuid: string) => {
  const criteria = props.userSearchCriteriaList.find(
    (criteria) => criteria.uuid === uuid
  );
  if (!criteria) {
    throw new Error('Criteria not found');
  }

  showDeleteDialog.value = true;
  deleteSearchCriteriaId.value = uuid;
};

const clickEventListener = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (!showMyFilterTooltip.value || !tooltipRef.value) {
    return;
  }
  if (!tooltipRef.value.contains(target)) {
    showMyFilterTooltip.value = false;
    tooltipRef.value.style.width = 'auto';
  }
};

const reset = () => {
  activeEditCriteria.value = undefined;
  formName.value = '';
};

watchEffect(() => {
  if (showMyFilterTooltip.value) {
    document.addEventListener('click', clickEventListener);
  } else {
    document.removeEventListener('click', clickEventListener);
    reset();
  }
});

onBeforeUnmount(() => {
  document.removeEventListener('click', clickEventListener);
});

return { __sfc: true,m, props, emits, activeEditCriteria, formRef, isValidForm, formName, tooltipRef, isLoading, showDeleteDialog, deleteSearchCriteriaId, COMPANY_FEATURES, isFeatureActive, generateInactiveMessage, showMyFilterTooltip, isActiveMyFilter, handleNameClick, handleEditClick, handleSaveClick, handleDeleteClick, clickEventListener, reset, isValidLength, noLineBreak, required, DeleteMyFilterDialog, MyFilterIcon, sharedMessages }
}

})